module.exports = __webpack_public_path__ + "img/3d_电梯底图.ede234e9.png";